import React from "react";
import {
  IonModal,
  IonCardContent,
  IonCardHeader,
  IonCard,
  IonRow,
  IonCol,
  IonButton
} from "@ionic/react";
import * as Constants from "../../../../utils/constants";
import "./BookLoadModal.scss";
import { IONICWrapper } from "../../../../utils/common";
import { FormatText } from "../../../../pages/Menu/FormatTextComponent/formatText";
import { decimal_2_place } from "../../../utils/BasicLogical.Util";

interface BookLoadModalProps {
  isBookLoadModal: boolean;
  bookedDetails: any;
  buyLoad: any;
  declineBookLoad: any;
  carrierId: any;
  lead: string;
  loadId: string;
  isManaged?: boolean;
}
export const BookLoadModal: React.FC<BookLoadModalProps> = ({
  isBookLoadModal,
  bookedDetails,
  buyLoad,
  declineBookLoad,
  loadId,
  isManaged
}) => {
  const decimalTotalCharge = (
    Math.round(bookedDetails.totalCharge * 100) / 100
  ).toFixed(2);
  return (
    <>
      <IonModal
        isOpen={isBookLoadModal}
        cssClass="bookload_modal"
        backdropDismiss={false}
      >
        <IonCard className="BookLoadCard">
          <IonCardHeader className="start-trip-cardContent">
            {Constants.VIEW_RATE_DETAILS}
          </IonCardHeader>
          <IonCardContent className="book-card-content">
            <div className="book-load-cardContent">
              <IonRow className="content-row heading">
                <IonCol
                  className="reference-type-header book-header"
                  size="4.5"
                >
                  {Constants.CHARGE_DESCRIPTION}
                </IonCol>
                <IonCol
                  className="reference-type-header book-load-col2 book-header"
                  size="7.5"
                >
                  <IonRow>
                    <IonCol size="4.5" className="book-load-col3 ">
                      {Constants.RATE_QUALIFIER}
                    </IonCol>
                    <IonCol size="3" className="book-load-col3 ">
                      {Constants.BOOLOAD_QTY}
                    </IonCol>
                    <IonCol size="4.5" className="book-load-col">
                      {Constants.BOOKLOAD_TOTAL}
                    </IonCol>
                  </IonRow>
                </IonCol>
              </IonRow>
              <IonCardContent className="rate-card-scroll">
                <BookLoadTable
                  bookloadName={bookedDetails.lineHaulCharge.chargeDescription}
                  rateQualifier={bookedDetails.lineHaulCharge.rateQualifier}
                  quantity={bookedDetails.lineHaulCharge.quantity}
                  charge={bookedDetails.lineHaulCharge.charge}
                  unitCharge={bookedDetails.lineHaulCharge.unitCharge}
                />
                <BookLoadTable
                  bookloadName={bookedDetails.fuelCharge.chargeDescription}
                  rateQualifier={bookedDetails.fuelCharge.rateQualifier}
                  quantity={bookedDetails.fuelCharge.quantity}
                  charge={bookedDetails.fuelCharge.charge}
                  unitCharge={bookedDetails.fuelCharge.unitCharge}
                />

                {bookedDetails.accessorials.map(
                  (bookLoad: any, index: number) => (
                    <BookLoadTable
                      key={index}
                      bookloadName={bookLoad.accessorialDescription}
                      rateQualifier={
                        bookLoad.accessorialCharge
                          ? bookLoad.accessorialCharge.rateQualifier
                          : "No Data"
                      }
                      quantity={
                        bookLoad.accessorialCharge
                          ? bookLoad.accessorialCharge.quantity
                          : "No Data"
                      }
                      charge={
                        bookLoad.accessorialCharge
                          ? bookLoad.accessorialCharge.charge
                          : "No Data"
                      }
                      unitCharge={
                        bookedDetails.accessorialCharge
                          ? decimal_2_place(bookLoad.accessorialCharge.unitCharge)
                          : "No Data"
                      }
                    />
                  )
                )}
              </IonCardContent>
              <IonRow className="book-load-row">
                <IonCol>Total</IonCol>
                <IonCol className="Total-count">${decimalTotalCharge}</IonCol>
              </IonRow>
            </div>
          </IonCardContent>
          <p className="terms_conditions_text_title">
            {Constants.TERMS_CONDITIONS.TERMS_CONDITIONS_HEADER}
          </p>
          <div className="terms_conditions_p">
            <FormatText
              text={
                isManaged
                  ? IONICWrapper.details.getKeyValuePairs(
                      Constants.TERMS_CONDITIONS.MANAGED
                    ) || Constants.TERMS_CONDITIONS.MANAGED_CONTENT
                  : IONICWrapper.details.getKeyValuePairs(
                      Constants.TERMS_CONDITIONS.UNMANAGED
                    ) || Constants.TERMS_CONDITIONS.UNMANAGED_CONTENT
              }
              dataType={"richText"}
            />
          </div>
          <IonRow>
            <IonCol size="12" className="D-Flex-Center">
              <IonButton
                className="secondary-cta-btn-web "
                data-test="ToastMessage-IonButton1"
                onClick={() => declineBookLoad()}
              >
                {Constants.BOOKLOAD_DECLINE_CTA_TEXT}
              </IonButton>
              &nbsp;&nbsp;&nbsp;
              <IonButton
                className="primary-cta-btn-web"
                data-test="acceptBuyLoad"
                onClick={() => buyLoad(loadId)}
              >
                {Constants.BOOKLOAD_ACCEPT_CTA_TEXT}
              </IonButton>
            </IonCol>
          </IonRow>
        </IonCard>
      </IonModal>
    </>
  );
};

export const BookLoadTable = (props: any) => {
  const decimalCharge = (Math.round(props.charge * 100) / 100).toFixed(2);
  return (
    <>
      <IonRow className="book-header-border content-row">
        <IonCol className="reference-val " size="4.5">
          {props.bookloadName}
        </IonCol>
        <IonCol size="7.5">
          <IonRow>
            <IonCol
              className="reference-val bookload-OK book-load-col3"
              size="4.5"
            >
              {`${decimal_2_place(props.unitCharge)}/${props.rateQualifier}`}
            </IonCol>
            <IonCol
              className="reference-val book-load-col3  bookload-OK"
              size="3"
            >
              {props.quantity}
            </IonCol>
            <IonCol className="reference-val book-load-col " size="4.5">
              ${decimalCharge}
            </IonCol>
          </IonRow>
        </IonCol>
      </IonRow>
    </>
  );
};
